import "../css/snor.scss"

// Our modules / classes
import Accordion from "./modules/Accordion"
import MenuHover from "./modules/MenuHover"
import MobileMenu from "./modules/MobileMenu"
import TnsSlider from "./modules/TnsSlider"
import Search from "./modules/Search"

// Instantiate a new object using our modules/classes
const accordion = new Accordion()
const menuHover = new MenuHover()
const mobileMenu = new MobileMenu()
// const heroSlider = new HeroSlider()

const tnsSlider = new TnsSlider()
//const tnsSlider = new TnsSlider() // members
//const tnsSlider = new TnsSlider() // services
//const tnsSlider = new TnsSlider() // methodes

const search = new Search()
